import { render, staticRenderFns } from "./foodcom.vue?vue&type=template&id=02a99d14&scoped=true"
import script from "./foodcom.vue?vue&type=script&lang=js"
export * from "./foodcom.vue?vue&type=script&lang=js"
import style0 from "./foodcom.vue?vue&type=style&index=0&id=02a99d14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a99d14",
  null
  
)

export default component.exports